/* eslint-disable no-unused-vars */

import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import CountryPhoneInput from "../shared/CountryPhoneInput";

export const AddRestaurant = () => {
  const navigate = useNavigate();
  const [franchises, setFranchises] = useState([]);
  const [focused, setFocused] = useState(false);
  const [focusedd, setFocusedd] = useState(false);
  const [focuseddd, setFocuseddd] = useState(false);
  useEffect(() => {
    const fetchFranchises = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_URL}/franchise`
        );
        setFranchises(response.data.data);
      } catch (error) {
        console.error("Error fetching franchises:", error);
      }
    };

    fetchFranchises();
  }, []);

  const [nameRes, setNameRes] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [franchiseFK, setFranchiseFK] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [taxIdentification, setTaxIdentification] = useState("");
  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_URL}/restau`,
        {
          nameRes,
          email,
          phone,
          address,
          franchiseFK,
          firstName,
          lastName,
          taxIdentification,
        }
      );

      // Vérifier si la réponse contient un message d'erreur
      if (response.data.error) {
        const errorMessage = response.data.error;

        if(nameRes == "" || email == "" || phone == "" || address == "" || franchiseFK == "" || firstName == "" || lastName == "" || taxIdentification == ""){
          swal("WARNING", "Required field", "warning");
        }
        else if (errorMessage.includes("Restaurant with this name already exist")) {
          swal("WARNING", "Restaurant with this name already exist", "warning");
        } else if (
          errorMessage.includes("Restaurant with this email already exist")
        ) {
          swal(
            "WARNING",
            "Restaurant with this email already exist",
            "warning"
          );
        } else if (
          errorMessage.includes(
            "Restaurant with this tax identification number already exist"
          )
        ) {
          swal(
            "WARNING",
            "Restaurant with this tax identification number already exist",
            "warning"
          );
        } else {
          swal("WARNING", `Error : ${errorMessage}`, "warning");
        }
      } else {
        // Si la création réussit, vous pouvez naviguer ou afficher un succès
        swal("SUCCESS", "Restaurant created with success!", "success");
        swal("Info", "Email is sent to the restaurant including a temporary password !", "Info");
        navigate("/restaurants");
      }
    } catch (error) {
      console.error("Erreur lors de la soumission:", error);
      const errorMessage = error.response.data.error;

      // Afficher l'alerte spécifique en fonction de l'erreur
      if (errorMessage.includes("Restaurant with this name already exist")) {
        swal("WARNING", "Restaurant with this name already exist", "warning");
      } else if (
        errorMessage.includes("Restaurant with this email already exist")
      ) {
        swal("WARNING", "Restaurant with this email already exist", "warning");
      } else if (
        errorMessage.includes(
          "Restaurant with this tax identification number already exist"
        )
      ) {
        swal(
          "WARNING",
          "Restaurant with this tax identification number already exist",
          "warning"
        );
      } else {
        swal("WARNING", `Error : ${errorMessage}`, "warning");
      }
      // swal('DANGER', 'An error occurred while creating the restaurant.', 'error');
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col-xl-6 col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Owner Information</h4>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="row">
                    <div className="form-group mb-3 col-md-6">
                      <label className="form-label">First name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label className="form-label">Last name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3 col-md-12">
                      <label className="form-label">Owner Email</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder=""
                        onChange={(e) => setEmail(e.target.value)}
                        onFocus={() => setFocuseddd(true)}
                        onBlur={() => setFocuseddd(false)}
                      />
                    </div>
                    <div className="form-group mb-3 col-md-12">
                      <label className="form-label">Owner Phone</label>
                      <CountryPhoneInput
                        value={phone}
                        onChange={(nextPhone) => setPhone(nextPhone)}
                        inputClassName="bg-white form-control"
                        inputStyle={{
                          height: "55px",
                          borderRadius: "5px",
                          border: "1px solid #DBDDE6",
                        }}
                        inputProps={{
                          name: "phone",
                        }}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6 col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Brand Information</h4>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="row">
                    <div className="form-group mb-3 col-md-12">
                      <label className="form-label">Restaurant Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""
                        value={nameRes}
                        onChange={(e) => setNameRes(e.target.value)}
                        onFocus={() => setFocused(true)}
                        onBlur={() => setFocused(false)}
                      />
                    </div>

                    <div className="form-group mb-3 col-md-12">
                      <label className="form-label">Tax Identification</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""
                        onChange={(e) => setTaxIdentification(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3 col-md-12">
                      <label className="form-label">Full Address</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""
                        onChange={(e) => setAddress(e.target.value)}
                        onFocus={() => setFocusedd(true)}
                        onBlur={() => setFocusedd(false)}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group mb-3 col-md-12">
                      <label className="form-label">Franchise (optional)</label>
                      <select
                        defaultValue={"option"}
                        id="inputState"
                        className="form-control"
                        value={franchiseFK}
                        onChange={(e) => setFranchiseFK(e.target.value)}
                      >
                        <option value="">Select Franchise</option>
                        {franchises.map((franchise) => (
                          <option
                            key={franchise._id}
                            value={franchise._id}
                            className="custom-option"
                          >
                            {franchise.nameFr}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="container">
              <div className="form-group justify-content-end d-flex mx-2 mb-3">
                <button
                  onClick={onSubmit}
                  type="submit"
                  className="btn btn-primary w-50"
                >
                  Finish Creation
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
